// theme/sidebarBrand.js
//
// Single source of truth for the Jaipuria maroon sidebar, imported
// byte-for-byte by BOTH src/MainLayout/Sidebar.js (Manager, Technician,
// Staff, Developer, Data Analyst) and src/components/AdminLayout/Sidebar.js
// (Admin) so the two sidebars are never "similar" -- they share the exact
// same gradient, gold accent, icon/text colors and active-item math. Each
// file still owns its own layout/markup (Admin's nested collapsible groups
// vs the flat DB-driven menu here), but every color/weight/radius value
// used to paint a menu row comes from here.

export const SIDEBAR_GRADIENT =
  "linear-gradient(180deg, #97113F 0%, #850D36 38%, #720A2F 68%, #5F0828 100%)";

export const SIDEBAR_GOLD = "#D9A82E";
export const SIDEBAR_TEXT = "#ffffff";
export const SIDEBAR_ICON = "rgba(255, 255, 255, 0.92)";
export const SIDEBAR_ICON_ACTIVE = "#ffffff";
export const SIDEBAR_ACTIVE_BG = "rgba(255, 255, 255, 0.12)";
export const SIDEBAR_ACTIVE_BG_HOVER = "rgba(255, 255, 255, 0.17)";
export const SIDEBAR_HOVER_BG = "rgba(255, 255, 255, 0.07)";

// Menu-row geometry -- identical on both sidebars.
export const SIDEBAR_ITEM_MIN_HEIGHT = 54;
export const SIDEBAR_ITEM_RADIUS = "10px";
export const SIDEBAR_ITEM_GAP = 14; // px, icon-to-label gap

// Label typography -- "clean white, not grey, not bold by default".
export const sidebarLabelSx = (active) => ({
  fontSize: 16,
  fontWeight: active ? 600 : 400,
  lineHeight: 1.4,
  color: SIDEBAR_TEXT,
  whiteSpace: "nowrap",
});

// Icon color -- near-white at rest, pure white when active.
export const sidebarIconColor = (active) => (active ? SIDEBAR_ICON_ACTIVE : SIDEBAR_ICON);

// Active/inactive row background + gold left rail. Each caller still
// supplies its own minHeight/padding/margin (layouts differ slightly --
// Admin's rows sit inside a narrower rail) but every color here is shared.
export const sidebarRowSx = (active) => ({
  borderRadius: SIDEBAR_ITEM_RADIUS,
  background: active ? SIDEBAR_ACTIVE_BG : "transparent",
  borderLeft: active ? `4px solid ${SIDEBAR_GOLD}` : "4px solid transparent",
});
